export enum UVCondition {
  CombatCapableIntact = 'combat_capable_intact',
  CombatCapableMinorDamage = 'combat_capable_minor_damage',
  NonCombatCapableRequiresRepair = 'non_combat_capable_requires_repair',
  NonCombatCapableCriticalDamage = 'non_combat_capable_critical_damage',
  LostBeforeLineOfContact = 'lost_before_line_of_contact',
  LostBeyondLineOfContact = 'lost_beyond_line_of_contact'
}

export const isUVLost = (condition: string | undefined) =>
  condition === UVCondition.LostBeforeLineOfContact || condition === UVCondition.LostBeyondLineOfContact;

export const isUVDamagedOrLost = (condition: string | undefined) =>
  condition === UVCondition.NonCombatCapableRequiresRepair ||
  condition === UVCondition.NonCombatCapableCriticalDamage ||
  isUVLost(condition);
